import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Schemas } from '~/api/gen'
import { MoreHorizIcon } from '~/components/icons/generated/MoreHorizIcon'
import { Popup } from '~/components/modules/Popup'
import { ShareButtons } from '~/components/modules/ShareButtons'
import { SpamCategories } from '~/components/modules/SpamModal/SpamCategories'
import { useBinary } from '~/hooks/useBinary'
import { useIsLoggedIn } from '~/hooks/useIsLoggedIn'
import { useIsLoginMember } from '~/hooks/useIsLoginMember'
import { useModal } from '~/hooks/useModal'
import { useCoordinateDetailShareUrl } from '../hooks/useCoordinateDetailShareUrl'

const SpamModal = dynamic(
  () =>
    import('~/components/modules/SpamModal/SpamModal').then((mod) => ({
      default: mod.SpamModal,
    })),
  {
    ssr: false,
  }
)

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
}

export const CoordinateHeaderPopup: React.FC<Props> = ({ coordinate }) => {
  const [isOpenPopup, , , togglePopup] = useBinary()
  const [Modal, open, close, isOpen] = useModal(300)
  const isLoggedIn = useIsLoggedIn()
  const pathUsername = useRouter().query.username
  const isLoginMemberContent = useIsLoginMember(
    typeof pathUsername === 'string' ? pathUsername : ''
  )
  const snsShareUrls = useCoordinateDetailShareUrl(
    coordinate.id,
    coordinate.member.user_name
  )

  return (
    <div className="relative">
      <button className="p-2" onClick={togglePopup} type="button">
        <MoreHorizIcon
          className="h-[22px]"
          aria-label={
            isOpenPopup
              ? 'アクションメニューを閉じる'
              : 'アクションメニューを開く'
          }
        />
      </button>
      <div className="absolute left-[-25px] top-[56px] z-coordinateDetailHeaderPopup ml-[-74px]">
        <Popup open={isOpenPopup} arrowPosition="right">
          <div className="px-2 py-[6px]">
            <ShareButtons {...snsShareUrls} />
          </div>
          <p className="w-full border-t border-gray-300">
            <a
              href={`wear2020://wear.jp/coordinate/${coordinate.id}/`}
              className="block w-full py-3 text-center text-[11px] leading-[1.4]"
            >
              アプリで開く
            </a>
          </p>
          {isLoggedIn && !isLoginMemberContent && (
            <button
              onClick={open}
              className="w-full border-t border-gray-300 py-3 text-[11px] leading-[1.4]"
              type="button"
            >
              通報
            </button>
          )}
        </Popup>
      </div>
      <Modal
        className={`transition-opacity duration-200 ease-linear ${
          isOpen ? 'opacity-100' : 'opacity-0'
        }`}
        overlayClassName={`ease-linear duration-200 transition-opacity bg-black/80 ${
          isOpen ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <SpamModal
          type={SpamCategories.Coordinate}
          close={close}
          targetId={coordinate.id}
        />
      </Modal>
    </div>
  )
}
